import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { aboutTeamMembers } from '../../data/aboutContent'
import { BUTTON_TRANSITION } from '../../theme/buttonHover'
import { mobileBodyTextSx, mobileSectionTitleSx } from '../../theme/mobileLayout'
import { scale } from '../../theme/scale'

const PHOTO_FRAME_HEIGHT = 260
const VIEWPORT_HEIGHT = 792

export default function MeetOurTeamDesktop() {
  const [activeIndex, setActiveIndex] = useState(0)

  const scrollOffset = Math.min(
    activeIndex * PHOTO_FRAME_HEIGHT,
    aboutTeamMembers.length * PHOTO_FRAME_HEIGHT - VIEWPORT_HEIGHT,
  )

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '80px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '249px',
          alignItems: 'flex-start',
        }}
      >
        <Typography
          component="h2"
          sx={{
            ...mobileSectionTitleSx,
            fontSize: scale.fontSize.sectionTitle,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            flexShrink: 0,
            whiteSpace: 'nowrap',
          }}
        >
          Meet Our Team
        </Typography>
        <Typography
          sx={{
            ...mobileBodyTextSx,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            maxWidth: 820,
          }}
        >
          The dedicated leaders and visionaries driving Disha Foundation&apos;s mission forward.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '50px',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            flex: 1,
            maxWidth: 1200,
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
          }}
        >
          {aboutTeamMembers.map((member, index) => (
            <Box key={member.name}>
              <Typography
                component="button"
                type="button"
                onClick={() => setActiveIndex(index)}
                onMouseEnter={() => setActiveIndex(index)}
                sx={{
                  fontSize: 30,
                  lineHeight: 'normal',
                  fontWeight: 400,
                  color: '#111',
                  opacity: activeIndex === index ? 1 : 0.6,
                  textAlign: 'left',
                  width: '100%',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  transition: BUTTON_TRANSITION,
                }}
              >
                {member.name}
              </Typography>
              <Box
                sx={{
                  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                  mt: '32px',
                }}
              />
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            width: 220,
            maxWidth: 220,
            height: VIEWPORT_HEIGHT,
            overflow: 'hidden',
            flexShrink: 0,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              transform: `translateY(-${scrollOffset}px)`,
              transition: 'transform 0.4s ease',
            }}
          >
            {aboutTeamMembers.map((member) => (
              <Box
                key={member.name}
                sx={{
                  width: 220,
                  height: PHOTO_FRAME_HEIGHT,
                  overflow: 'hidden',
                  flexShrink: 0,
                  bgcolor: 'rgba(8, 39, 83, 0.08)',
                  position: 'relative',
                }}
              >
                <Box
                  component="img"
                  src={member.image}
                  alt={member.name}
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: member.objectPosition === 'bottom' ? 'auto' : 0,
                    bottom: member.objectPosition === 'bottom' ? 0 : 'auto',
                    transform: `translateX(-50%)${member.imageTransform ? ` ${member.imageTransform}` : ''}`,
                    width: '100%',
                    minWidth: 220,
                    height: member.objectPosition === 'bottom' ? 'auto' : '100%',
                    maxHeight: '125%',
                    objectFit: 'cover',
                    objectPosition: member.objectPosition || 'center',
                    display: 'block',
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
